module.exports = __webpack_public_path__ + "static/media/champyoga.8d9ecb7d.gif";